// src/i18n/index.ts
import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

const i18n = createI18n({
  legacy: false, // 必须设为 false，开启 Composition API 模式
  locale: 'zh-CN', // 默认语言
  fallbackLocale: 'en-US', // 当当前语言缺少翻译时，兜底使用英文
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
